import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { VesselStatuses } from 'server/enums/VesselStatus';
import { VesselServiceListing, VesselServiceListingParams } from './model';
import { VesselServiceListingView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export const VesselServiceListingRoute = (model : (params : VesselServiceListingParams) => VesselServiceListing, appWrapper : AppWrapper, request : Location) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper}>
            <VesselServiceListingView model={model(convertParams(request))} />
        </AppWrapperView>
});

function convertParams(request : Location) : VesselServiceListingParams {
    const statusParam = request.params['status'];

    return { status: parseVesselStatus(statusParam) };
}

function parseVesselStatus(strStatus : string | undefined) {
    if (strStatus === undefined) return null;
    for (let i = 0; i < VesselStatuses.length; i++) {
        if (strStatus.toLowerCase() === VesselStatuses[i].Name.toLowerCase()) {
            return VesselStatuses[i].Id;
        }
    }
    throw new Error('Unknown VesselStatus string ' + strStatus);
}


// WEBPACK FOOTER //
// ./apps/portcall/vesselservicelisting/route.tsx